// extracted by mini-css-extract-plugin
export default {"Navigation":"Navigation_Navigation__GE2ML","NavigationItem":"Navigation_NavigationItem__BpAV+"};